module.exports = __webpack_public_path__ + "img/tesla-coil.049d4528.png";